import { Toast } from 'mint-ui';
let common={
    //读取本地存储（兼容旧的 "name=value;expires=..." 格式）
    getlocalStorage(name) {
        let data = localStorage.getItem(name) || "";
        if (!data) {
            return null;
        }
        //兼容旧格式：userInfo=%7B...%7D;expires=...
        if (data.indexOf(name + "=") === 0) {
            const arr = data.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
            if (arr != null) {
                return unescape(arr[2]);
            }
            return null;
        }
        return data;
    },
    setlocalStorage(name, value) {
        //localStorage 无过期概念，直接存原值
        localStorage.setItem(name, value);
    },
    deletelocalStorage(name) {
        //只删除指定 key，避免 localStorage.clear() 误清其他业务数据
        localStorage.removeItem(name);
    },
    //设置cookie
    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
    },
    //获取cookie
    getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
        }
        return "";
    },
    //清除cookie
    clearCookie() {
        var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
        if(keys) {
            for(var i = keys.length; i--;){
                document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() + '; path=/';
            }
        }
    },
    //读取登录用户信息：localStorage 优先，cookie 兜底；未登录返回 null
    getUserInfo() {
        try {
            const str = this.getlocalStorage("userInfo");
            if (str) {
                const parsed = JSON.parse(str);
                if (parsed && parsed.token) {
                    return parsed;
                }
            }
        } catch (e) {
            //存储内容损坏时忽略，继续走 cookie 兜底
        }
        const token = this.getCookie("token");
        if (token) {
            return { token: token, mobile: this.getCookie("mobile") };
        }
        return null;
    },
    //保存登录用户信息：localStorage + cookie 双写，实现记住登录状态
    setUserInfo(userInfo) {
        if (!userInfo || !userInfo.token) {
            return;
        }
        this.setlocalStorage("userInfo", JSON.stringify(userInfo));
        this.setCookie("token", userInfo.token, 365);
        this.setCookie("mobile", userInfo.mobile || "", 365);
    },
    //清除登录状态
    clearUserInfo() {
        this.deletelocalStorage("userInfo");
        this.clearCookie();
    },
    //封装弹出框函数;
    toast(text){
        let instance =Toast({  
            message: text, //提示内容分
            position: "middle", //提示框位置
            duration: 3000 , //持续时间（毫秒），若为 -1 则不会自动关闭
            iconClass: "icon icon-success", //icon 图标的类名
            className:"addClass"   //Toast 的类名。可以为其添加样式
        });  
    }

};


export default common



// WEBPACK FOOTER //
// ./src/common.js